import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

const sanitise = ({id, venueId, ...rest}) => ({
    id:         Number(id),
    venueId:    Number(venueId),
    ...rest
});

class EventAssetStore extends ReduceStore{
    getInitialState() {
        return [];
    }

    getByVenue(venueId) {
        return this.getState().filter((e) => e !== undefined && e.venueId === venueId);
    }

    getIndex(assetId, venueId) {
        return this._state.findIndex((e) => e !== undefined && e.id === assetId && e.venueId === venueId);
    }

    reduce(state, action) {
        let data;
        switch (action.type) {
            case ActionTypes.VENUE_ASSET_LIST_SUCCESS:
                data = this.getState().filter((elem) => (!!elem && elem.venueId !== action.payload.venueId));
                return [
                    ...data,
                    ...action.data.map(sanitise)
                ];

            case ActionTypes.VENUE_ASSET_ADD_SUCCESS:
                return update(this.getState(), { $push: [action.data]});

            case ActionTypes.VENUE_ASSET_REMOVE_SUCCESS:
                if (action.data) {
                    const index = this.getIndex(action.payload.assetId, action.payload.venueId);
                    return update(this.getState(), { $splice: [[index, 1]] });
                }
                return state;

            default:
                return state;
        }
    }
}

export default new EventAssetStore(CentricDispatcher);
